import request from '../fetch/index.ts'
import * as Types from './types.ts'

export const getCompanyList = async () => {
  return request.get<Array<Types.CompanyListItem>>('/company/list')
}

export const login = async (params: Types.LoginReqsArgs) => {
  return request.post<Types.LoginRepsData>('/user/login', params)
}

export const logout = async () => {
  return await request.get<null>('/user/logout')
}

export const getUserInfoAPI = async () => {
  return request.get<Types.LoginRepsData>(
    '/user/info',
    {},
    {
      timeout: 5000
    }
  )
}
